import type { Messages } from './en.js';

/** Русский — совпадает по терминам с лендингом (Лента, Дубли, Коллекции…). */
export const ru: Messages = {
  // ── nav ────────────────────────────────────────────────────────────────
  'nav.timeline': 'Лента',
  'nav.search': 'Поиск',
  'nav.duplicates': 'Дубли',
  'nav.collections': 'Коллекции',
  'nav.import': 'Импорт',
  'nav.trash': 'Корзина',
  'nav.settings': 'Настройки',

  // ── common actions ─────────────────────────────────────────────────────
  'common.restore': 'Восстановить',
  'common.delete': 'Удалить',
  'common.cancel': 'Отмена',
  'common.save': 'Сохранить',
  'common.close': 'Закрыть',
  'common.upgrade': 'Улучшить',
  'common.upgradeToPro': 'Перейти на Pro',
  'common.search': 'Поиск',
  'common.tryAgain': 'Попробовать ещё раз',
  'common.loading': 'Загрузка…',
  'common.back': 'Назад',
  'common.skip': 'Пропустить',
  'common.verify': 'Проверить',
  'common.resend': 'Отправить ещё раз',
  'common.free': 'Free',
  'common.pro': 'Pro',
  'common.clearFilters': 'Сбросить фильтры',
  'common.addToChrome': 'Добавить в Chrome',
  'toast.genericError': 'Что-то пошло не так. Попробуйте ещё раз.',

  // ── plural units ───────────────────────────────────────────────────────
  'unit.tabs.one': '{count} вкладка',
  'unit.tabs.few': '{count} вкладки',
  'unit.tabs.many': '{count} вкладок',
  'unit.tabs.other': '{count} вкладки',
  'unit.sessions.one': '{count} сессия',
  'unit.sessions.few': '{count} сессии',
  'unit.sessions.many': '{count} сессий',
  'unit.sessions.other': '{count} сессии',
  'unit.items.one': '{count} элемент',
  'unit.items.few': '{count} элемента',
  'unit.items.many': '{count} элементов',
  'unit.items.other': '{count} элемента',
  'unit.entries.one': '{count} запись',
  'unit.entries.few': '{count} записи',
  'unit.entries.many': '{count} записей',
  'unit.entries.other': '{count} записи',
  'unit.copies.one': '{count} копию',
  'unit.copies.few': '{count} копии',
  'unit.copies.many': '{count} копий',
  'unit.copies.other': '{count} копии',
  'unit.browsers.one': '{count} браузер',
  'unit.browsers.few': '{count} браузера',
  'unit.browsers.many': '{count} браузеров',
  'unit.browsers.other': '{count} браузера',

  // ── app shell ──────────────────────────────────────────────────────────
  'shell.searchPlaceholder': 'Искать в хранилище…',
  'shell.saved': 'СОХРАНЕНО',
  'shell.toggleTheme': 'Сменить тему',

  // ── timeline ───────────────────────────────────────────────────────────
  'timeline.empty.title': 'Хранилище пока пустое',
  'timeline.empty.body':
    'Сметите окно расширением TabVault или спасите свою старую свалку OneTab. Всё окажется здесь — и всё ищется.',
  'timeline.empty.import': 'Импортировать вкладки',
  'timeline.empty.importOneTab': 'Импорт из OneTab',
  'timeline.empty.tip': 'СОВЕТ: ⇧⌘S СМЕТАЕТ ТЕКУЩЕЕ ОКНО ИЗ РАСШИРЕНИЯ',
  'timeline.noMatch.title': 'Ни одна сессия не подходит под фильтры',
  'timeline.noMatch.body': 'Расширьте период, выберите другой браузер или выключите «только с контентом».',
  'timeline.loadOlder': 'Показать более старые сессии',
  'timeline.toast.sessionDeleted': 'Сессия удалена',
  'timeline.toast.loadFailed': 'Не удалось загрузить эту сессию',
  'timeline.delete.title': 'Удалить эту сессию?',
  'timeline.delete.subtitle': 'Будет удалена «{title}» и {tabs}. Это действие необратимо.',
  'timeline.delete.body': 'Если передумаете, вкладки всё ещё можно вернуть из истории браузера.',
  'timeline.delete.confirm': 'Удалить сессию',
  'timeline.delete.fallbackTitle': 'эта сессия',
  'timeline.offline.title': 'Вы офлайн',
  'timeline.offline.body': 'Хранилище работает локально — синхронизация продолжится сама, когда появится сеть.',
  'timeline.error.title': 'Не удалось загрузить ленту',
  'timeline.error.body': 'Не получилось связаться с хранилищем. Проверьте соединение и попробуйте ещё раз.',

  // ── search ─────────────────────────────────────────────────────────────
  'search.mode.text': 'Текст',
  'search.mode.hybrid': 'Гибрид',
  'search.mode.semantic': 'Смысл',
  'search.placeholder': 'Искать в хранилище…',
  'search.clear': 'Очистить поиск',
  'search.status.counted': 'ИЩЕМ СРЕДИ {count} ВКЛАДОК',
  'search.status.default': 'ИЩЕМ В ВАШЕМ ХРАНИЛИЩЕ',
  'search.empty.title': 'Ищите по всему, что сохранили',
  'search.empty.body':
    'Находите вкладку по заголовку, адресу или словам на странице. Смысловой режим ищет по смыслу.',
  'search.noMatch.title': 'Ничего не найдено по запросу «{q}»',
  'search.noMatch.body': 'Попробуйте меньше или другие слова, переключитесь на «Гибрид» или сбросьте фильтры.',
  'search.failed.eyebrow': '— ПОИСК НЕ УДАЛСЯ',
  'search.failed.body': 'Не получилось связаться с хранилищем.',
  'search.failed.retryHint': 'Попробуйте ещё раз.',
  'search.results': 'РЕЗУЛЬТАТОВ: {count}',
  'search.sort.relevance': 'Релевантность',
  'search.sort.date': 'Дата',
  'search.loadMore': 'Показать ещё',
  'search.bestMatch': 'ЛУЧШЕЕ СОВПАДЕНИЕ',
  'search.openedIn': 'ВЫ ОТКРЫВАЛИ ЭТО В {browser}',
  'search.facet.browser': 'БРАУЗЕР',
  'search.facet.date': 'ДАТА',
  'search.facet.topDomains': 'ТОП ДОМЕНОВ',
  'search.range.any': 'За всё время',
  'search.range.24h': '24 часа',
  'search.range.7d': '7 дней',
  'search.range.30d': '30 дней',
  'search.range.1y': '12 месяцев',
  'search.upsell.eyebrow': 'СМЫСЛОВОЙ ПОИСК · PRO',
  'search.upsell.title': 'Смысловой поиск — функция Pro',
  'search.upsell.body':
    'Находите вкладки по смыслу, а не только по словам — «та статья про снижение ставки ЦБ» вместо точного заголовка. Перейдите на Pro и ищите по всему, что когда-либо сохранили.',
  'search.upsell.seePlans': 'Посмотреть тарифы Pro',
  'search.upsell.useText': 'Искать по тексту',

  // ── duplicates ─────────────────────────────────────────────────────────
  'dupes.title': 'Центр дублей',
  'dupes.summary.duplicates': 'ДУБЛЕЙ: {count}',
  'dupes.summary.ram': '≈ {ram} RAM ОСВОБОДИТСЯ',
  'dupes.closeSelected': 'Закрыть выбранные ({count})',
  'dupes.keepNewest': 'Оставить свежую, закрыть остальные',
  'dupes.error.title': 'Не удалось загрузить дубли',
  'dupes.toast.closed': 'Закрыто: {copies}',
  'dupes.toast.closedBody': 'Самая свежая копия остаётся открытой — все копии по-прежнему сохранены в хранилище.',

  // ── collections ────────────────────────────────────────────────────────
  'collections.title': 'Коллекции',
  'collections.subtitle': 'Автосортировка ИИ — переименовывайте и объединяйте когда угодно',
  'collections.new': 'Новая коллекция',
  'collections.banner.title': 'ИИ-коллекции — функция Pro.',
  'collections.banner.body': 'Собирать и вести коллекции вручную можно и так — это бесплатно, навсегда.',
  'collections.empty.title': 'Коллекций пока нет',
  'collections.empty.body':
    'Группируйте вкладки по темам. Создайте коллекцию вручную — а Pro ещё и раскладывает хранилище по коллекциям сам.',
  'collections.error.title': 'Не удалось загрузить коллекции',

  // ── import ─────────────────────────────────────────────────────────────
  'import.title': 'Импортируйте свои старые свалки вкладок',
  'import.drop.title': 'Перетащите файл экспорта сюда',
  'import.drop.body': 'OneTab, Session Buddy или HTML закладок —',
  'import.drop.browse': 'выбрать файл',
  'import.readyEyebrow': 'ГОТОВО К ИМПОРТУ',

  // ── settings ───────────────────────────────────────────────────────────
  'settings.title': 'Настройки',
  'settings.section.account': 'АККАУНТ И СИНК',
  'settings.section.browsers': 'ПОДКЛЮЧЁННЫЕ БРАУЗЕРЫ',
  'settings.section.capture': 'ПРАВИЛА ЗАХВАТА',
  'settings.section.sharing': 'ПУБЛИЧНЫЕ ССЫЛКИ',
  'settings.section.storage': 'ХРАНИЛИЩЕ',
  'settings.section.appearance': 'ОФОРМЛЕНИЕ',
  'settings.section.language': 'ЯЗЫК',
  'settings.section.about': 'О ПРИЛОЖЕНИИ',
  'settings.section.danger': 'ОПАСНАЯ ЗОНА',
  'settings.account.private': 'ПРИВАТНО И БЕЗОПАСНО',
  'settings.account.yourAccount': 'Ваш аккаунт',
  'settings.account.proPlan': 'ТАРИФ PRO',
  'settings.account.freePlan': 'ТАРИФ FREE',
  'settings.account.managePlan': 'Управлять тарифом',
  'settings.account.seePro': 'Про Pro',
  'settings.account.privacyNote':
    'Сохранённые страницы приватны — видите их только вы. Мы храним их надёжно и вне чужого доступа.',
  'settings.account.billing': 'Оплата и счета',
  'settings.browsers.syncAuto': 'Остальные синхронизируются сами',
  'settings.browsers.thisBrowser': 'Этот браузер',
  'settings.browsers.webApp': 'ВЕБ-ПРИЛОЖЕНИЕ',
  'settings.browsers.activeNow': 'СЕЙЧАС АКТИВЕН',
  'settings.browsers.installHint':
    'Установите расширение в другие браузеры — они появятся здесь и будут синхронизироваться автоматически.',
  'settings.capture.onDevice': 'НА ЭТОМ УСТРОЙСТВЕ',
  'settings.capture.saveContent': 'Сохранять контент страниц для поиска',
  'settings.capture.saveContentDesc': 'Только текст — хранится приватно для полнотекстового поиска',
  'settings.capture.skipIncognito': 'Пропускать окна инкогнито',
  'settings.capture.neverOn': 'Никогда не захватывать контент на:',
  'settings.capture.addSite': '+ добавить сайт',
  'settings.capture.localNote':
    'Пока эти правила живут в этом браузере — синхронизация между устройствами скоро появится.',
  'settings.sharing.readOnly': 'Публичные ссылки только для чтения',
  'settings.sharing.collection': 'Коллекция',
  'settings.sharing.sweep': 'Свип',
  'settings.sharing.selectCollection': 'Выберите коллекцию…',
  'settings.sharing.selectSweep': 'Выберите свип…',
  'settings.sharing.createLink': 'Создать ссылку',
  'settings.sharing.empty.title': 'Публичных ссылок пока нет',
  'settings.sharing.empty.body': 'Создайте публичную ссылку на коллекцию или свип — доступ только для чтения.',
  'settings.sharing.copyLink': 'Скопировать ссылку',
  'settings.sharing.revoke': 'Отозвать',
  'settings.toast.linkCreated': 'Ссылка создана',
  'settings.toast.linkCreatedBody': 'Открыть её сможет любой, у кого она есть — только для чтения.',
  'settings.toast.linkFailed': 'Не удалось создать ссылку',
  'settings.toast.linkFailedBody': 'Попробуйте ещё раз через минуту.',
  'settings.toast.linkRevoked': 'Ссылка отозвана',
  'settings.toast.linkRevokedBody': 'Эта ссылка больше не открывается.',
  'settings.toast.revokeFailed': 'Не удалось отозвать ссылку',
  'settings.toast.revokeFailedBody': 'Попробуйте ещё раз.',
  'settings.toast.copied': 'Скопировано',
  'settings.toast.copiedBody': 'Ссылка в буфере обмена.',
  'settings.toast.deleteFailed': 'Не удалось удалить',
  'settings.toast.deleteFailedBody': 'Не получилось удалить аккаунт. Попробуйте ещё раз.',
  'settings.danger.export': 'Экспортировать все данные',
  'settings.danger.deleteAccount': 'Удалить аккаунт и данные',
  'settings.danger.note': 'Сначала экспортируйте — через 14 дней удаление необратимо.',
  'settings.storage.saved': 'Сохранено: {count}',
  'settings.storage.tabs': 'ВКЛАДКИ',
  'settings.storage.sessions': 'СЕССИИ',
  'settings.storage.indexed': 'В ИНДЕКСЕ',
  'settings.appearance.dark': 'Тёмная тема',
  'settings.appearance.darkDesc': 'Глубокий тёмно-синий — вид по умолчанию',
  'settings.language.label': 'Язык интерфейса',
  'settings.language.desc': 'Применяется сразу и везде в приложении.',
  'settings.promo.title': 'Установите расширение',
  'settings.promo.body': 'Сметайте целое окно одним кликом прямо из панели браузера.',
  'settings.about.webApp': 'Веб-приложение',
  'settings.about.extension': 'Расширение',
  'settings.deleteModal.title': 'Удалить аккаунт и данные',
  'settings.deleteModal.subtitle': 'Хранилище будет удалено везде.',
  'settings.deleteModal.body':
    'Каждый свип, сохранённая страница и коллекция будут поставлены на удаление. 14 дней их ещё можно вернуть, потом — безвозвратно. Если данные могут пригодиться, сначала экспортируйте их.',
  'settings.deleteModal.keep': 'Оставить аккаунт',
  'settings.deleteModal.confirm': 'Удалить всё',
  'settings.planModal.title': 'Управление тарифом Pro',
  'settings.planModal.subtitle': 'Free остаётся щедрым — Pro соединяет всё.',
  'settings.planModal.body':
    'Отмените в любой момент — Pro будет действовать до конца оплаченного периода. Дальше: локальные сохранения без лимитов, синхронизация — один браузер, а ИИ-поиск и коллекции встанут на паузу.',
  'settings.planModal.nothingDeleted': 'Ничего не удаляется.',
  'settings.planModal.emailSupport': 'Написать в поддержку для отмены',
  'settings.planModal.keepPro': 'Оставить Pro',

  // ── login / verify ─────────────────────────────────────────────────────
  'login.welcome': 'Добро пожаловать в TabVault',
  'login.tagline': 'Одно хранилище для всех ваших браузеров.',
  'login.emailPlaceholder': 'you@email.com',
  'login.sendLink': 'Отправить волшебную ссылку',
  'login.error.tooMany': 'Слишком много запросов — подождите минуту и попробуйте снова.',
  'login.error.sendFailed': 'Не получилось отправить ссылку. Попробуйте ещё раз чуть позже.',
  'login.reassure': 'Сохранённые страницы приватны — открыть хранилище можете только вы.',
  'login.checkInbox': 'Проверьте почту',
  'login.sentTo': 'Мы отправили ссылку для входа на',
  'login.expires': 'ССЫЛКА ДЕЙСТВУЕТ 15 МИНУТ',
  'login.nothingThere': 'Ничего не пришло?',
  'login.checkSpam': 'проверьте спам',
  'login.wrongAddress': '← Не тот адрес? Вернуться',
  'login.devDivider': 'DEV · ВСТАВЬТЕ ТОКЕН',
  'login.tokenPlaceholder': 'токен из консоли API',
  'verify.signingIn': 'Входим…',
  'verify.hangTight': 'Секундочку, это займёт мгновение.',
  'verify.expired.title': 'Срок действия ссылки истёк',
  'verify.expired.body':
    'Волшебные ссылки работают 15 минут и только один раз. Запросите новую — и вы сразу внутри.',
  'verify.backToSignIn': 'Назад ко входу',

  // ── onboarding ─────────────────────────────────────────────────────────
  'onboarding.hero.title1': 'У вашего браузера',
  'onboarding.hero.title2': 'наконец есть память.',
  'onboarding.hero.body':
    'Сметайте целые окна в хранилище, закрывайте их без страха и находите любую страницу снова — по тому, что на ней было написано.',
  'onboarding.getStarted': 'Начать',
  'onboarding.hero.micro': 'ЗАЙМЁТ 60 СЕКУНД · СМОТРЕТЬ МОЖНО БЕЗ АККАУНТА',
  'onboarding.perm.title': 'Почему браузер просит доступ',
  'onboarding.perm.lede': 'Следующее окно звучит страшно. Вот что оно значит на самом деле.',
  'onboarding.perm.head': '«ПРОСМОТР И ИЗМЕНЕНИЕ ВСЕХ ДАННЫХ НА ВСЕХ САЙТАХ» — ПЕРЕВОДИМ',
  'onboarding.perm.p1.title': 'Мы читаем страницы только чтобы сделать их искомыми',
  'onboarding.perm.p1.body': 'Чтобы потом вы нашли «ту статью про ипотечные ставки».',
  'onboarding.perm.p2.title': 'Ваши страницы остаются приватными на вашем устройстве',
  'onboarding.perm.p2.body': 'Открыть хранилище можете только вы — мы не видим, что вы сохраняете.',
  'onboarding.perm.p3.title': 'Банки, почту и приватные сайты можно исключить',
  'onboarding.perm.p3.body': 'Один список в Настройках — там контент не захватывается никогда.',
  'onboarding.perm.continue': 'Звучит честно — продолжить',
  'onboarding.perm.later': 'Спросить позже',
  'onboarding.perm.micro': 'ЭТО МОЖНО ИЗМЕНИТЬ В ЛЮБОЙ МОМЕНТ В НАСТРОЙКАХ',
  'onboarding.rescue.title': 'Спасите свои вкладки прямо сейчас',
  'onboarding.rescue.lede': 'Выберите вариант — оба занимают меньше минуты, и ничего не теряется.',
  'onboarding.rescue.onetab.title': 'Импорт из OneTab',
  'onboarding.rescue.onetab.body':
    'Перенесите всю свалку OneTab одним кликом — группы станут сессиями.',
  'onboarding.rescue.chooseFile': 'Выбрать файл',
  'onboarding.rescue.onetab.foot': 'А ТАКЖЕ: SESSION BUDDY · HTML ЗАКЛАДОК',
  'onboarding.rescue.ext.title': 'Установите расширение',
  'onboarding.rescue.ext.body':
    'Сметайте целое окно одним кликом прямо из панели. Смотрите, как возвращается RAM.',
  'onboarding.rescue.ext.foot': 'CHROME · EDGE · ЯНДЕКС · COMET',
  'onboarding.rescue.openApp': 'Открыть веб-приложение →',

  // ── pricing ────────────────────────────────────────────────────────────
  'pricing.title': 'Переходите на Pro, когда будете готовы',
  'pricing.subtitle': 'Free остаётся щедрым. Pro соединяет всё.',
  'pricing.monthly': 'Месяц ${price}',
  'pricing.yearly': 'Год ${price}',
  'pricing.forever': 'НАВСЕГДА',
  'pricing.yourPlan': 'ВАШ ТАРИФ',
  'pricing.mostLoved': 'ЛЮБИМЫЙ ВЫБОР',
  'pricing.perMonth': '/МЕС',
  'pricing.perMonthYearly': '/МЕС · ${total} РАЗ В ГОД',
  'pricing.free.f1': 'Локальные сохранения без лимитов',
  'pricing.free.f2': '1 браузер с облачной синхронизацией',
  'pricing.free.f3': 'Поиск по заголовку и URL',
  'pricing.free.f4': 'Полнотекстовый и ИИ-поиск',
  'pricing.free.f5': 'ИИ-коллекции',
  'pricing.pro.f1': 'Все браузеры и устройства синхронизированы',
  'pricing.pro.f2': 'Полнотекстовый + смысловой ИИ-поиск',
  'pricing.pro.f3': 'ИИ-коллекции, которые сортируют себя сами',
  'pricing.pro.f4': 'История версий сохранённых страниц',
  'pricing.pro.f5': 'Приоритетная поддержка',
  'pricing.stayFree': 'Остаться на Free',
  'pricing.youreOnPro': 'У вас Pro',
  'pricing.signInToUpgrade': 'Войдите, чтобы перейти на Pro',
  'pricing.checkoutSoon': 'Оплата скоро откроется — мы напишем вам, как только всё заработает.',
  'pricing.checkoutFailed': 'Не получилось начать оплату. Попробуйте ещё раз.',
  'pricing.footer': 'ОТМЕНА В ЛЮБОЙ МОМЕНТ · ЭКСПОРТ ДАННЫХ КОГДА УГОДНО · ЛОКАЛЬНЫЕ СОХРАНЕНИЯ НЕ БЛОКИРУЮТСЯ',

  // ── billing / version history ──────────────────────────────────────────
  'billing.title': 'Оплата и счета',
  'versions.title': 'История версий',
  'versions.current': 'ТЕКУЩАЯ',
  'versions.restoreThis': 'Восстановить эту версию',

  // ── trash ──────────────────────────────────────────────────────────────
  'trash.title': 'Корзина',
  'trash.autoPurge': 'АВТООЧИСТКА ЧЕРЕЗ 14 ДНЕЙ',
  'trash.itemsLoading': '… ЭЛЕМЕНТОВ',
  'trash.restoreSelected': 'Восстановить выбранные ({count})',
  'trash.restoring': 'Восстанавливаем…',
  'trash.emptyTrash': 'Очистить корзину',
  'trash.error.title': 'Не удалось загрузить корзину',
  'trash.emptyState.title': 'Корзина пуста',
  'trash.emptyState.body':
    'Удалённые сессии и страницы ждут здесь 14 дней, потом стираются автоматически.',
  'trash.footNote': 'УДАЛЕНИЕ ИЗ КОРЗИНЫ НЕОБРАТИМО · ЭКСПОРТ ДАННЫХ — В НАСТРОЙКАХ → ОПАСНАЯ ЗОНА',
  'trash.purge.title': 'Удалить навсегда?',
  'trash.purge.subtitle': '«{title}» будет удалена безвозвратно — без 14 дней на восстановление.',
  'trash.purge.confirm': 'Удалить навсегда',
  'trash.purge.sweepBody': 'Сессия и {tabs} будут удалены безвозвратно.',
  'trash.purge.pageBody': 'Сохранённая страница и её контент будут удалены безвозвратно.',
  'trash.emptyConfirm.title': 'Очистить корзину?',
  'trash.emptyConfirm.subtitle': 'Безвозвратно удаляет {entries}.',
  'trash.emptyConfirm.body':
    'Всё в корзине исчезнет навсегда — это действие необратимо. Экспортировать данные можно в любой момент в Настройках → Опасная зона.',
  'trash.toast.restored': 'Восстановлено',
  'trash.toast.restoredBody': '«{title}» снова в вашем хранилище.',
  'trash.toast.restoredMany': 'Восстановлено: {entries}',
  'trash.toast.restoreFailed': 'Не удалось восстановить',
  'trash.toast.restoreManyFailed': 'Не удалось восстановить выбранное',
  'trash.toast.purged': 'Удалено навсегда',
  'trash.toast.purgedBody': '«{title}» удалена безвозвратно.',
  'trash.toast.purgeFailed': 'Не удалось удалить',
  'trash.toast.emptied': 'Корзина очищена',
  'trash.toast.emptiedBody': 'Всё содержимое корзины удалено безвозвратно.',
  'trash.toast.emptyFailed': 'Не удалось очистить корзину',
};
